import * as Types from '../../../generated/gqlTypes';

import { gql } from '@apollo/client';
export type RedirectFragment = { id: string, pk: number, oldPath: string, newPath: string };

export const RedirectFragmentDoc = gql`
    fragment RedirectFragment on RedirectType {
  id
  pk
  oldPath
  newPath
}
    `;